$(function () {
    slick_slider();
});

$(document).on("shopify:section:load", function () {
    slick_slider();
});

$(document).on("shopify:section:unload", function () {
  slick_slider();
});

$(document).on("shopify:section:select", function () {
  slick_slider();
});

$(document).on("shopify:section:deselect", function () {
  slick_slider();
});

function slick_slider() {

    // メインスライダー
    $('.js-slider--mv').not(".slick-initialized").slick({
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 600,
      infinite: true,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<div class="c-slider__arrow c-slider__arrow--prev c-slider__arrow--mvLeft"></div>',
      nextArrow: '<div class="c-slider__arrow c-slider__arrow--next c-slider__arrow--mvRight"></div>',
       dots: $('.p-mv__image.c-slider__image--mv').length > 1,
      dotsClass: 'c-slider__dots c-flex -jc-c -ai-c',
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      centerMode:true,
      centerPadding:"9.7%",
      responsive: [
        {
          breakpoint: 1041,
          settings: {
            slidesToShow: 1,
            centerPadding:"24.7%",
          },
        },
        {
          breakpoint: 769,
          settings: {
	        arrows: false,
            centerMode: false,
            slidesToShow: 1,
          },
        },
      ],
    });

    //カテゴリー
    $('.js-slider--category').not(".slick-initialized").slick({
      speed: 300,
      infinite: true,
      slidesToShow: 8,
      slidesToScroll: 8,
      arrows: true,
      prevArrow: '<div class="c-slider__arrow c-slider__arrow--prev c-slider__arrow--brand"></div>',
      nextArrow: '<div class="c-slider__arrow c-slider__arrow--next c-slider__arrow--brand"></div>',
      dots: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      responsive: [
        {
          breakpoint: 769,
          settings: "unslick",
        },
      ],
    });
}

$(window).on('resize orientationchange', function() {
  $('.js-slider--mv').slick('resize');
  $('.js-slider--category').slick('resize');
});